import { Computer } from "@material-symbols-svg/react/rounded/icons/computer";
import { MobileOff } from "@material-symbols-svg/react/rounded/icons/mobile-off";
import { useTranslation } from "react-i18next";
import { BrandLogo } from "@/shared/brand";

/** Shown instead of a sign-in or password form on a small screen (see
 *  `useSmallScreenNotice`). */
export function SmallScreenNotice() {
  const { t } = useTranslation("auth");
  return (
    <div className="flex w-full max-w-[326px] flex-col items-center text-center">
      <BrandLogo className="mb-10 h-6" />
      <span className="mb-5.5 grid size-18 place-items-center rounded-full bg-primary-container text-on-primary-container">
        <MobileOff aria-hidden className="size-8.5" />
      </span>
      <h1 className="mb-2.5 text-heading-medium tracking-[-0.56px] text-foreground">
        {t("smallScreenNotice.title")}
      </h1>
      <p className="text-body-medium text-muted-foreground">
        {t("smallScreenNotice.description")}
      </p>
      <div className="mt-5.5 flex w-full items-center gap-3 rounded-2xl bg-surface-lowest px-4 py-3.5 text-left shadow-elevation-medium">
        <span className="grid size-10 shrink-0 place-items-center rounded-full bg-surface-high text-foreground">
          <Computer aria-hidden className="size-5" />
        </span>
        <div className="flex flex-col">
          <h2 className="text-label-small-prominent text-foreground">
            {t("smallScreenNotice.nextSteps.title")}
          </h2>
          <p className="text-label-small text-muted-foreground">
            {t("smallScreenNotice.nextSteps.description")}
          </p>
        </div>
      </div>
    </div>
  );
}
